import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { NoteTemplateUpdateArgs } from "../types"

export const noteTemplateMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: NoteTemplateUpdateArgs }) => {
			await tx.mutate.feedbackTemplates.update(args)
		},
	),
}
